import { InjectionToken } from '@angular/core';
import { ISbStory, ISbStoryData } from '@storyblok/js';
import { Observable } from 'rxjs';
import { StoryblokStoriesQuery } from './lib/storyblok-cache-tags';
import { StoryblokLink } from './storyblok/storyblok-types';

export interface PicflowStoryblok {
  getStories(options: StoryblokStoriesQuery): Observable<{ stories: ISbStoryData[]; total: number }>;
  getStory(slug: string): Observable<ISbStory['data'] | false>;
  getUrlLink(link: StoryblokLink): string;
  getLinkName(link: StoryblokLink): string | undefined;
}

export const PICFLOW_STORYBLOK = new InjectionToken<PicflowStoryblok>('storyblok');
